// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStrengthMeter-Meter_cls1__3i5P9","cls2":"VeloStrengthMeter-Meter_cls2__657lq VeloStrengthMeter-Meter_cls1__3i5P9"};